import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.leads.general,
        label: 'General',
        permission: PERMISSIONS.leads.tabs.general.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.leads.communicationHub,
        label: 'Communication Hub',
        permission: PERMISSIONS.leads.tabs.communicationHub.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.leads.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.leads.tabs.task.read,
        id: '3',
      },
      {
        path: ADMIN_ROUTES.leads.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.leads.tabs.attachment.read,
        id: '4',
      },
      {
        path: ADMIN_ROUTES.leads.logs,
        label: 'Logs',
        permission: PERMISSIONS.leads.tabs.logs.read,
        id: '5',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
